
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addPromotions } from '../../../redux/actions/selectActions';
import Tabs from '../../tabs/index';
import Voucher from './voucher/voucher';
import ApiVoucher from '../../../api/open-voucher';
import PaymentApi from '../../../api/payment';
import Faqs from '../faqs';
import './index-voucher.css';

class IndexVoucher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      vouchers: null,
      loadingVouchers: true,
    };
    this.obtenerTodosLosVouchers = this.obtenerTodosLosVouchers.bind(this);
  }

  obtenerTodosLosVouchers(token) {
    ApiVoucher.getVoucherOfertas(token).then((data) => {
      if (data.status) {
        this.setState({
          vouchers: data.object.ofertas,
          loadingVouchers: false,
        });
      } else {
        this.setState({
          loadingVouchers: false,
        });
      }
    });
  }

  obtenerOpcionesDePago(token) {
    const { addPromotions } = this.props;
    PaymentApi.obtenerOpcionesPagoMundigea(token).then((res) => addPromotions(res.data));
  }

  componentDidMount() {
    const { app } = this.props;
    const { token } = app;
    this.obtenerTodosLosVouchers(token);
    this.obtenerOpcionesDePago(token);
  }

  createVoucher = (voucherOptions, key) => {
    return (
      <div key={`prod-${key}`} className='product-container'>
        <div className='container'>
          <Voucher voucherOptions={voucherOptions} />
        </div>
      </div>
    );
  }

  orderByFirstMinPrice = (voucherByType) => {
    return voucherByType.sort((a, b) => {
      return a[0].importe - b[0].importe;
    });
  }

  renderVouchers(vouchers, loadingVouchers) {
    if (loadingVouchers) {
      return this.createSkeleton();
    }
    if (vouchers) {
      const voucherTypes = [];
      vouchers.forEach((item) => {
        if (!voucherTypes[item.tipoVoucher.id]) {
          voucherTypes[item.tipoVoucher.id] = [];
        }
        voucherTypes[item.tipoVoucher.id] = [...voucherTypes[item.tipoVoucher.id]].concat(item);
      });

      let vouchersOrganized = [];
      voucherTypes.forEach((voucherOptions) => {
        vouchersOrganized[voucherOptions[0].tipoVoucher.id] = voucherOptions.sort((a, b) => {
          return a.usoVoucher.cantidadUsos - b.usoVoucher.cantidadUsos;
        });
      });

      vouchersOrganized = this.orderByFirstMinPrice(vouchersOrganized);

      return vouchersOrganized.map(
        (voucherOptions) => {
          return this.createVoucher(voucherOptions, voucherOptions[0].tipoVoucher.id);
        },
      );
    }
    return <h1 className='text-center'>No hay productos disponibles</h1>;

  }

  createSkeleton = () => {
    return (
      <>
        <div className='product-container'>
          <div className='container'>
            <Voucher data={null} />
          </div>
        </div>
        <div className='product-container'>
          <div className='container'>
            <Voucher data={null} />
          </div>
        </div>
      </>
    );
  }

  render() {
    const { vouchers, loadingVouchers } = this.state;
    const imgPrincipal = 'https://res.mundigea.com.ar/img/openvoucher/op-hotsale.jpg';
    return (
      <>
        <Tabs />
        <Faqs />
        <div className='p-img-principal'>
          <div className='container-elements'>
            <div className='container'>
              <div className='position-relative box-top'>
                <div className='box-1'>
                  <h1>
                    <span className='display-inline-block'>Ya tenés tu&nbsp;</span>
                    <span className='display-inline-block'> Open Voucher?</span>
                  </h1>
                  <p>
                    Activá tu Voucher y viví una experiencia única
                    <span className='display-inline-block'>cuando y dondo quieras</span>
                  </p>
                  <a className='btn-voucher color-dinamico-fondo' href='https://openvoucher.mundigea.com.ar' target='_blank' rel='noopener noreferrer'>
                    ¡Activalo hoy!
                  </a>
                </div>
              </div>
              <div className='clearfic' />
            </div>
            <img
              className='img-responsive img-principal'
              src={imgPrincipal}
              alt=''
            />
          </div>
        </div>
        <div className='container'>
          <div className='steps text-center'>
            <h1 className='steps-title'>VIVÍ UNA EXPERIENCIA INIGUALABLE POST CUARENTENA</h1>
            <p style={{ fontSize: '1.5em', color: '#444444' }}>
              Seleccionamos los mejores establecimientos de Argentina para que nuestro
              {' '}
              <b>OPEN VOUCHER</b>
              {' '}
              te permita agendar escapadas de una forma segura, fácil y rápida. Adquiriendo las categorías Premium o Classic de un
              {' '}
              <b>OPEN VOUCHER</b>
              {' '}
              quedan habilitados todos los alojamientos con un 30% de descuento, financiación en cuotas y la seguridad sanitaria requerida debido al contexto actual. Vos elegís a cuantos destinos queres ir!
              <br />
              <i>Válido hasta el 31 de Marzo de 2021.</i>
            </p>
            <br />
            <br />
            <br />
            <h1 className='steps-title'>CÓMO FUNCIONA EL OPEN VOUCHER</h1>
            <div className='row'>
              <div className='col-md-4 col-sm-4 col-xs-12'>
                <div className='info-container'>
                  <img className='img-responsive img-info-voucher' src='/assets/img/step_01.png' alt='1' />

                  <p>
                    Elegí tu categoria de
                    <b className='display-inline-block'>Open Voucher</b>
                    {' '}
                    con pago Online o en una Agencia de Viajes hasta en 12 cuotas.
                  </p>
                </div>
              </div>
              <div className='col-md-4 col-sm-4 col-xs-12'>
                <div className='info-container'>
                  <img className='img-responsive img-info-voucher' src='/assets/img/step_02.png' alt='2' />
                  <p>
                    Conocé los establecimientos y las experiencias disponibles
                    <b>2021</b>
                  </p>
                </div>
              </div>
              <div className='col-md-4 col-sm-4 col-xs-12'>
                <div className='info-container'>
                  <img className='img-responsive img-info-voucher' src='/assets/img/step_03.png' alt='3' />
                  <p>
                    Agendá tus escapadas, con un Open Voucher vas a disfrutar de tu país
                    <b>cuando quieras y en distintos alojamientos!</b>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='product-container'>
          <br />
          {this.renderVouchers(vouchers, loadingVouchers)}
        </div>

      </>
    );
  }
}

const mapStateToProps = (state) => ({
  app: state.applicationState,
});

const mapDispatchtoProps = (dispatch) => bindActionCreators({ addPromotions }, dispatch);

export default connect(mapStateToProps, mapDispatchtoProps)(IndexVoucher);
